import React, { useEffect } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import i18n from './i18n';
import { useNavigate } from "react-router-dom";

import {getFlagByLanguageCode, getLanguageFlagMap} from "./helper/language";


const Flag = (props) => {
    const { onHide } = props;
    let navigate = useNavigate();
    useEffect(() => {
        // cL();
    }, [navigate])


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <Row>
                    <Col className="flag">
                        {Object.keys(getLanguageFlagMap()).map((langCode) => (
                          <div
                            key={langCode}
                            onClick={() => {
                                onHide();
                                i18n.changeLanguage(langCode);
                                navigate(`?lang=${langCode}`);
                            }}
                            className={i18n.language === langCode ? 'active' : ''}
                          >
                              <img src={getFlagByLanguageCode(langCode)} alt={langCode} />
                          </div>
                        ))}
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default Flag;